import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import CursorGlow from "./components/CursorGlow";
import KennelLayout from "./pages/kennel/KennelLayout";
import KennelHome from "./pages/kennel/KennelHome";
import KennelDogs from "./pages/kennel/KennelDogs";
import KennelDogProfile from "./pages/kennel/KennelDogProfile";
import KennelLitters from "./pages/kennel/KennelLitters";
import KennelContact from "./pages/kennel/KennelContact";
import KennelPlans from "./pages/kennel/KennelPlans";
import KennelPuppies from "./pages/kennel/KennelPuppies";
import KennelGallery from "./pages/kennel/KennelGallery";
import KennelVideos from "./pages/kennel/KennelVideos";
import KennelAbout from "./pages/kennel/KennelAbout";
import KennelLitter from "./pages/kennel/KennelLitter";
import KennelBreed from "./pages/kennel/KennelBreed";
import KennelLegal from "./pages/kennel/KennelLegal";
import KennelPuppySEO from "./pages/kennel/KennelPuppySEO";
import KennelKnowledge from "./pages/kennel/KennelKnowledge";
import KennelArticle from "./pages/kennel/KennelArticle";
import KennelReviewForm from "./pages/kennel/KennelReviewForm";
import KennelTraining from "./pages/kennel/KennelTraining";
import KennelBlog from "./pages/kennel/KennelBlog";
import KennelBlogPost from "./pages/kennel/KennelBlogPost";
import KennelAdminReviews from "./pages/kennel/KennelAdminReviews";
import KennelAdminGallery from "./pages/kennel/KennelAdminGallery";
import KennelAdminLitters from "./pages/kennel/KennelAdminLitters";
import KennelAdminBlog from "./pages/kennel/KennelAdminBlog";
import AnatomyPage from "./pages/kennel/AnatomyPage";
import AtlasLayout from "./pages/atlas/AtlasLayout";
import AtlasHub from "./pages/atlas/AtlasHub";
import AtlasLayerPage from "./pages/atlas/AtlasLayerPage";

function App() {
  return (
    <div className="App" style={{ margin: 0, padding: 0 }}>
      <CursorGlow />
      <BrowserRouter>
        <Routes>
          {/* Review form - outside layout (no header/footer) */}
          <Route path="/dodaj-opinie/:token" element={<KennelReviewForm />} />

          {/* Szkolenia - HIDDEN page for client approval (NOT in main menu) */}
          <Route path="/szkolenia" element={<KennelTraining />} />
          
          {/* Admin panel - outside layout */}
          <Route path="/admin/opinie" element={<KennelAdminReviews />} />
          <Route path="/admin/galeria" element={<KennelAdminGallery />} />
          <Route path="/admin/mioty" element={<KennelAdminLitters />} />
          <Route path="/admin/blog" element={<KennelAdminBlog />} />
          
          {/* Atlas Anatomy - separate product */}
          <Route path="/anatomia/owczarek-niemiecki" element={<AtlasLayout />}>
            <Route index element={<AtlasHub />} />
            <Route path=":slug" element={<AtlasLayerPage />} />
          </Route>

          <Route path="/" element={<KennelLayout />}>
            <Route index element={<KennelHome />} />
            <Route path="o-hodowli" element={<KennelAbout />} />
            <Route path="psy" element={<KennelDogs />} />
            <Route path="psy/:dogId" element={<KennelDogProfile />} />
            <Route path="mioty" element={<KennelLitters />} />
            <Route path="mioty/:litterId" element={<KennelLitter />} />
            <Route path="plany" element={<KennelPlans />} />
            <Route path="szczenieta" element={<KennelPuppies />} />
            <Route path="galeria" element={<KennelGallery />} />
            <Route path="galeria/filmy" element={<KennelVideos />} />
            <Route path="wiedza-o-rasie" element={<KennelKnowledge />} />
            <Route path="wiedza-o-rasie/:slug" element={<KennelArticle />} />
            <Route path="z-zycia-hodowli" element={<KennelBlog />} />
            <Route path="z-zycia-hodowli/:slug" element={<KennelBlogPost />} />
            <Route path="kontakt" element={<KennelContact />} />
            <Route path="owczarek-niemiecki" element={<KennelBreed />} />
            <Route path="szczenieta-owczarka-niemieckiego" element={<KennelPuppySEO />} />
            <Route path="anatomia-owczarka-niemieckiego" element={<AnatomyPage />} />
            <Route path="anatomia" element={<Navigate to="/anatomia-owczarka-niemieckiego" replace />} />
            <Route path=":slug" element={<KennelLegal />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
